<template>
  <div>
    <form-wizard @on-complete="onComplete"
      :title="init ? 'Wir richten nun dein Restaurant ein' : 'Überprüfe deine Angaben erneut'"
      :subtitle="init ? 'Dazu brauchen wir ein paar Informationen' : null"
      back-button-text="zurück"
      next-button-text="weiter"
      finish-button-text="Fertigstellen"
      color="rgba(255,193,7,1)"
      @on-validate="handleValidation"
        @on-error="handleErrorMessage"
    >
        <wizard-step 
            slot-scope="props"
            slot="step"
            :tab="props.tab"
            :transition="props.transition"
            :index="props.index">
        </wizard-step>
        <tab-content title="Persönliche Infos"
                      icon="ti-user"
                      :before-change="validateAsyncStep1"
                      >

          <b-alert show variant="danger" v-if="errorMsg">{{errorMsg}}</b-alert>
          
          <h4 class="text-center">Persönliche Informationen / Rechnungsadresse</h4>
          <b-row class="m-0 mt-4 justify-content-center w-100">
            <b-form @submit.prevent="onSubmit">

              <b-row class="m-0 justify-content-center w-100">
                <b-col cols="12" md="6" style="width: 40vw;">
                  <b-form-group
                    label="Vorname:"
                  >
                    <b-form-input
                      :state="!userInformations.firstname ? false : true"
                      v-model="userInformations.firstname"
                      type="text"
                      placeholder="Vorname eingeben..."
                      required
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group  label="Nachname:" >
                    <b-form-input
                    :state="!userInformations.lastname ? false : true"
                      name="nachname"
                      v-model="userInformations.lastname"
                      type="text"
                      placeholder="Nachname eingeben..."
                      required
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group label="Telefonnummer:" >
                    <b-form-input
                      :state="!userInformations.contact.phone ? false : true"
                      v-model="userInformations.contact.phone"
                      type="text"
                      placeholder="Telefonnummer eingeben..."
                      required
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group label="E-Mail:">
                    <b-form-input
                      v-model="userInformations.email"
                      type="text"
                      disabled
                      placeholder="E-Mail eingeben..."
                      required
                    ></b-form-input>
                  </b-form-group>

                </b-col>
                <b-col cols="12" md="6" style="width: 40vw;">

                  <b-form-group label="Straße & Hausnummer:" >
                    <b-form-input
                    :state="!userInformations.adress.street ? false : true"
                      v-model="userInformations.adress.street"
                      placeholder="Straße & Nr. eingeben..."
                      required
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group label="Postleitzahl:" >
                    <b-form-input
                    :state="!userInformations.adress.zipcode ? false : true"
                      v-model="userInformations.adress.zipcode"
                      placeholder="Postleitzahl eingeben..."
                      required
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group label="Stadt:" >
                    <b-form-input
                    :state="!userInformations.adress.city ? false : true"
                      v-model="userInformations.adress.city"
                      placeholder="Stadt eingeben..."
                      required
                    ></b-form-input>
                  </b-form-group>

                  

                  <b-form-group label="Land:">
                    <b-form-select
                      :state="!userInformations.adress.country ? false : true"
                      v-model="userInformations.adress.country"
                      :options="countriesSelect"
                      required
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              

            </b-form>
            <ThemifyIcon icon="user" v-if="false" />
          </b-row>

        </tab-content>
        <tab-content title="Restaurant Info"
                      icon="ti-wallet"
                      :before-change="validateAsyncStep2"
                      >

          <b-alert v-if="init" dismissible show variant="warning">Achtung: Du kannst den Namen deines Restaurants nach Abschluss nicht mehr ändern!</b-alert>
          <b-alert show variant="danger" v-if="errorMsg">{{ errorMsg }}</b-alert>
          <h4 class="text-center">Restaurantinformationen</h4>
          <b-row class="m-0 mt-4 justify-content-center w-100">
            <b-form @submit.prevent="onSubmit">

              <b-row class="m-0 justify-content-center w-100">
                <b-col cols="12" md="6" style="width: 40vw;">
                  <b-form-group
                    label="Restaurantname:"
                  >
                    <b-input-group class="">
                    <b-form-input
                      :disabled="!init ? true : false"
                    :state="!restaurant.title ? false : true"
                      v-model="restaurant.title"
                      type="text"
                      placeholder="Restaurantname eingeben..."
                      required
                    ></b-form-input>

                    <template #append>
                      <b-input-group-text v-if="false">
                        <b-spinner small label="Spinning"></b-spinner>
                      </b-input-group-text>
                    </template>

                    </b-input-group>
                  </b-form-group>

                  <b-form-group
                    label="Kurzbeschreibung:"
                    description="z.B.: Das beste Schnitzel in der Stadt!"
                  >
                    <b-form-input
                    :state="!restaurant.description ? false : true"
                      v-model="restaurant.description"
                      type="text"
                      placeholder="Kurzbeschreibung eingeben..."
                      required
                    ></b-form-input>
                  </b-form-group>
                  
                  <b-form-group label="Telefonnummer:" description="Diese Telefonnummer wird dem Kunden angezeigt.">
                    <b-form-input
                      :state="!restaurant.contact.phone ? false : true"
                      v-model="restaurant.contact.phone"
                      type="text"
                      placeholder="Telefonnummer eingeben..."
                      required
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group :class="$route.query.mobilenumber ? 'p-2 rounded pulse' : ''" label="Mobilnummer:" description="An diese Telefonnummer werden gegebenenfalls Informationen per SMS gesendet.">
                    <b-form-input
                      :state="!restaurant.contact.mobile ? false : true"
                      v-model="restaurant.contact.mobile"
                      type="text"
                      placeholder="Mobilnummer eingeben..."
                      required
                    ></b-form-input>
                  </b-form-group>

                    <!-- <b-form-group label="E-Mail:" description="Diese E-Mail wird für eingehende Bestellungen verwendet.">
                    <b-form-input
                    :state="!restaurant.contact.email ? false : true"
                      name="nachname"
                      v-model="restaurant.contact.email"
                      type="email"
                      placeholder="Email eingeben..."
                      required
                    ></b-form-input>
                  </b-form-group> -->

                </b-col>
                <b-col cols="12" md="6" style="width: 40vw;">
                  
                  <b-form-group label="Adresse finden:" >
                  <vue-google-autocomplete
                      ref="address"
                      id="map"
                      classname="form-control"
                      :placeholder="getPlaceholder()"
                      v-on:placechanged="getAddressData"
                      country="de"
                  >
                  </vue-google-autocomplete>
                  </b-form-group>
                  
                  <b-form-group label="Straße & Hausnummer:" >
                    <b-form-input
                      size="sm"
                      :state="!restaurant.adress.street ? false : true"
                      v-model="restaurant.adress.street"
                      placeholder="Straße & Nr. eingeben..."
                      required
                      disabled
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group label="Postleitzahl:" >
                    <b-form-input
                      :state="!restaurant.adress.zipcode ? false : true"
                      v-model="restaurant.adress.zipcode"
                      placeholder="Postleitzahl eingeben..."
                      size="sm"
                      required
                      disabled
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group label="Stadt:">
                    <b-form-input
                    :state="!restaurant.adress.city ? false : true"
                      v-model="restaurant.adress.city"
                      placeholder="Stadt eingeben..."
                      size="sm"
                      required
                      disabled
                    ></b-form-input>
                  </b-form-group>

                  

                  <b-form-group  label="Land:" >
                    <b-form-select
                      :state="!restaurant.adress.country ? false : true"
                      v-model="restaurant.adress.country"
                      :options="countriesSelect"
                      size="sm"
                      required
                      disabled
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </b-row>
        </tab-content>
        <tab-content title="Logo hochladen"
                      icon="ti-image"
                      :before-change="validateAsyncStep3">
          
          <b-alert dismissible show>Tipp: Das beste Ergebnis wird mit Transparenten PNG Logos erziehlt!</b-alert>
          <b-alert show variant="danger" v-if="errorMsg">Es wurde kein Logo ausgewählt!</b-alert>
          <div class="image-preview py-3" v-if="imageData.length > 0">
            <img class="preview" alt="new" style="max-height: 200px" :src="imageData">
          </div>
          <div v-if="company">
          <div class="image-preview py-3" v-if="!imageData && company.img">
            <img class="preview" alt="new" style="max-height: 200px" :src="getImage(company.img.image)">
          </div>
          </div>
          <b-form-file
            @change="previewImage" accept="image/*"
            v-model="file1"
            :state="Boolean(file1)"
            placeholder="Wähle eine Datei aus..."
            drop-placeholder="Hier her ziehen..."
          ></b-form-file>
          <div class="mt-3">Ausgewählte Datei: {{ file1 ? file1.name : '' }}</div>
        </tab-content>
        <tab-content title="Fertig!"
                      icon="ti-check">
          <div v-if="!initDone">
            <b-alert dismissible show>Tipp: Du kannst diese Einstellungen (mit Ausnahme des Restaurantnamens!) nach Abschluss jederzeit in deinem Profil ändern</b-alert>
            <h3>Vorschau:</h3>
            <div v-if="company">
              <restaurant-regular v-if="company.img" :city="restaurant.adress.city" :distance="'0.0'" :street="restaurant.adress.street" :name="restaurant.title" :img="company.img.image" :description="restaurant.description" ></restaurant-regular>
            </div>
          </div>
          <div class="pt-5" v-else>
            <b-alert dismissible show>Tipp: Du kannst diese Einstellungen (mit Ausnahme des Restaurantnamens!) nach Abschluss jederzeit in deinem Profil ändern</b-alert>
            <h3 class="p-5 text-center"> Einstellungen gespeichert! </h3>
          </div>
        </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import coreData from '@/mixins/coreDataMixin'
import ThemifyIcon from "vue-themify-icons";
import axiosAuth from '@/shared/configs/axios-auth'
import RestaurantRegular from '@/views/components/RestaurantRegular'
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
  name: 'InitWizardComponent',
  mixins: [coreData],
  
  components: {
    ThemifyIcon,
    RestaurantRegular,
    VueGoogleAutocomplete
  },
  props: {
    init: Boolean
  },
  data: () => {
    return {
      addressData: null,
      initDone: false,
      loadingWizard: false,
         errorMsg: null,
         count: 0,
      imageData: "",
      file1: null,
      countriesSelect: [{ text: 'auswählen...', value: null }, 'Deutschland'],
      form: {},
      restaurant: {
        adress: {},
        contact: {}
      },
    }
  },
  watch:{
    company(){
      if(this.company){
        this.restaurant = this.company
      }
    }
  },
  computed: {
    
  },
  created(){
    if(this.company){
        this.restaurant = this.company
      }
  },
  methods: {
    getPlaceholder(){
      if(this.adressData){
        return this.adressData.route + ' , ' + this.adressData.locality + ' , ' + this.adressData.country
      }
      return 'Adresse des Restaurants eingeben...'
    },
    getAddressData: function (addressData) {
      this.addressData = addressData;
      this.restaurant.adress = {
        city: addressData.locality,
        country: addressData.country,
        zipcode: addressData.postal_code,
        street: addressData.route + ' ' + addressData.street_number,
        lon: addressData.longitude,
        lat: addressData.latitude,
        addressData: addressData
      }
      localStorage.setItem('adressData', JSON.stringify(this.adressData))
    },
     onComplete: function(){
          try {
            axiosAuth.patch('/users/me', {initDone: true})
            .then(
                () => {
                  this.userInformations.initDone = true
                  this.initDone = true
                  window.location.reload()
                }
              )
            .catch(
                error => {
                  alert('NOPE. DOPE');
                    console.log(error.response)

                }
            ) 
            
          } catch (error) {
            console.log(error)
          }
           
        },
        setLoading: function(value) {
            this.loadingWizard = value
        },
        handleValidation: function(isValid, tabIndex){
           console.log('Tab: '+tabIndex+ ' valid: '+isValid)
        },
        handleErrorMessage: function(errorMsg){
          console.log(errorMsg)
          this.errorMsg = errorMsg
        },
        validateAsyncStep1:function() {
          return new Promise((resolve, reject) => {

              if(!this.userInformations.firstname || !this.userInformations.lastname || !this.userInformations.contact.phone || !this.userInformations.adress.street || !this.userInformations.adress.zipcode || !this.userInformations.adress.city || !this.userInformations.adress.country){
                reject('Es wurden nicht alle Felder ausgefüllt!')
              }else{
                const payload = {
  
                  firstname: this.userInformations.firstname,
                  lastname: this.userInformations.lastname,
                  adress: {
                    street: this.userInformations.adress.street,
                    zipcode: this.userInformations.adress.zipcode,
                    city: this.userInformations.adress.city,
                    country: this.userInformations.adress.country,
                  },
                  contact:{
                    email: this.userInformations.email,
                    phone: this.userInformations.contact.phone,
                  } 
                }
                try {
                  axiosAuth.patch('/users/me', payload)
                  .then(
                      () => {
                          resolve(true)
                      }
                    )
                  .catch(
                      error => {
                          console.log(error.response)
                          reject(error.response.data)
                      }
                  ) 
                  
                } catch (error) {
                  reject(error)
                }
                
                
              }

          })
         },
        
        validateAsyncStep2:function() {
          return new Promise((resolve, reject) => {

              if(!this.restaurant.title || !this.restaurant.description || !this.restaurant.contact.phone || !this.restaurant.adress.street || !this.restaurant.adress.zipcode || !this.restaurant.adress.city || !this.restaurant.adress.country){
                reject('Es wurden nicht alle Felder ausgefüllt!')
              }else{
                if(!this.company){
                  axiosAuth.post('/companies', this.restaurant)
                    .then(
                        () => {
                            this.$store.dispatch('getCompany')
                            resolve(true)
                        }
                    )
                    .catch(
                    error => {
                      
                        console.log(error.response)
                        reject(error.response.data)
                    }
                  )
                }else{

                  var testString = this.company.contact.mobile.substring(0,3)
                  var mobileNumber = '+49' + parseInt(this.company.contact.mobile, 10)
                  if(testString === '+49'){
                    mobileNumber = this.company.contact.mobile
                  }
                  console.log('mobilenumber', mobileNumber)
                  this.company.contact.mobile = mobileNumber
                  
                  var payload = {
                    title: this.company.title,
                    description: this.company.description,
                    adress: {
                        city: this.company.adress.city,
                        street: this.company.adress.street,
                        zipcode: this.company.adress.zipcode,
                        country: this.company.adress.country,
                        lon: this.company.adress.lon,
                        lat: this.company.adress.lat,
                        addressData: this.company.adress.addressData
                    },
                    contact: {
                        email: this.company.contact.email,
                        phone: this.company.contact.phone,
                        mobile: this.company.contact.mobile
                    },
                  }

                  axiosAuth.patch('/companies/'+ this.company._id, payload)
                    .then(
                        () => {
                          this.$store.dispatch('getCompany')
                          resolve(true)
                        }
                      )
                    .catch(
                        error => {
                            console.log(error.response)
                        reject(error.response.data)
                        }
                    ) 
                }
                
              }

          })
         },

         validateAsyncStep3:function() {
          return new Promise((resolve, reject) => {

              if(!this.file1 && !this.company.img){
                reject('Es wurde kein Logo hochgeladen!')
              }else{
                
                if(this.imageData){
                  let formData = new FormData();

                    formData.append('company', this.company._id)
                    formData.append('image', this.file1);

                    axiosAuth.post('companies/upload', formData,)
                      .then(
                        () => {
                          this.$store.dispatch('getCompany')
                          resolve(true)
                        }
                      )
                    .catch(
                        error => {
                            console.log(error.response)
                        reject(error.response.data)
                        }
                    ) 
                }else{
                  resolve(true)
                }
                    

              }

          })
         },

        previewImage: function(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
          // create a new FileReader to read this image and convert to base64 format
          var reader = new FileReader();
          // Define a callback function to run, when FileReader finishes its job
          reader.onload = (e) => {
              // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
              // Read image as base64 and set to imageData
              this.imageData = e.target.result;
          }
          // Start the reader job - read file as a data url (base64 format)
          reader.readAsDataURL(input.files[0]);
      }
    }
  }
}
</script>

<style lang="scss" >

</style>
